import { placeTagsApi } from "api/placeTagsApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const usePlaceTags = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.PLACE_TAGS(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => placeTagsApi.fetch(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.PLACE_TAGS(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, placeTags: data?.data.data ?? [], total: data?.data.total ?? 0 };
};

export const usePlaceTagsOptions = () => {
  const { isLoading, placeTags } = usePlaceTags(0, 1_000_000);

  const options = placeTags.map((x) => ({
    value: x.id.toString(),
    label: x.name,
  }));

  return { loading: isLoading, options };
};
